// Small, dependency-free date helpers for the student UI (all times are shown in the viewer's local timezone).
const MIN = 60000, HOUR = 3600000, DAY = 86400000;

/** "Just now", "12 min ago", "3 h ago", "Yesterday", "12 Sep". */
export function timeAgo(iso, now = Date.now()) {
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return '';
  const d = now - t;
  if (d < 0) return formatWhen(iso);                       // in the future: show the date, not "-3 min ago"
  if (d < MIN) return 'Just now';
  if (d < HOUR) return `${Math.floor(d / MIN)} min ago`;
  if (d < DAY) return `${Math.floor(d / HOUR)} h ago`;
  if (d < 2 * DAY) return 'Yesterday';
  if (d < 7 * DAY) return `${Math.floor(d / DAY)} days ago`;
  return new Date(t).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
}

/** "Mon 22 Sep, 10:30 am" — for upcoming things. */
export function formatWhen(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-IN', { weekday: 'short', day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' });
}
